/**
 * A single subgroup of checkboxes, meant to be used together with several
 * other InputGroupPanels components to make up one filter section (e.g. location section, venue section)
 */
import * as React from 'react';
import cn from 'classnames';
const _styles = require('./index.scss');

interface ChildProps {
    collapsed?: boolean;
    children: React.SFC<{ collapsed: boolean }>;
}

export const ContentCollapsible = (props: React.PropsWithChildren<ChildProps>) => {
    return <div className={cn({ [_styles.contentCollapsed]: !!props.collapsed })}>{props.children({ collapsed: !!props.collapsed })}</div>;
};
export const ContentPersistent = (props: React.PropsWithChildren<{}>) => {
    return <div>{props.children}</div>;
};

export interface InputGroupPanelProps {
    title?: string;
    collapsible: boolean;
    defaultCollapsed: boolean;
    seeMoreText?: string;
    seeLessText?: string;
    children: React.ReactElement<ChildProps>[] | React.ReactElement<ChildProps>;
}

export const InputGroupPanel = (props: React.PropsWithChildren<InputGroupPanelProps>) => {
    const [groupCollapsed, setGroupCollapsed] = React.useState(props.defaultCollapsed);

    const { seeMoreText, seeLessText } = props;

    return (
        <div className={'inputGroup'}>
            <div className={'inputGroupTitle'}>{props.title}</div>
            <div className={'inputGroupContent'}>
                {React.Children.map(props.children, (child) => {
                    return React.cloneElement(child as React.ReactElement<ChildProps>, { collapsed: groupCollapsed });
                })}
            </div>
            {props.collapsible && (
                <div className={'inputGroupToggle'}>
                    <button onClick={() => setGroupCollapsed(!groupCollapsed)}>
                        <div className={'toggleSign'}>{groupCollapsed ? '+' : '–'}</div>
                        <div className={'toggleText'}>{groupCollapsed ? seeMoreText || 'See More' : seeLessText || 'See Less'}</div>
                    </button>
                </div>
            )}
        </div>
    );
};
